import { render } from "./icon.vue?vue&type=template&id=75d71fbd"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/components/icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75d71fbd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75d71fbd', __exports__)) {
    console.log('reload')
    api.reload('75d71fbd', __exports__)
  }
  
  module.hot.accept("./icon.vue?vue&type=template&id=75d71fbd", () => {
    console.log('re-render')
    api.rerender('75d71fbd', render)
  })

}


export default __exports__